import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const createAndUpdateShadowProjectAssignments = async (
  projectId,
  assignmentsToCreate,
  assignmentsToUpdate,
  isUserModifiedAssignments,
  activeEmployerInfo = {}
) => {
  const apiPath = `shadow-data/projects/${projectId}/assignments/create-and-update-assignments`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      assignmentsToCreate,
      assignmentsToUpdate,
      isUserModifiedAssignments,
    },
    activeEmployerInfo,
    isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
